"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.RWSToolsProductCompareDataComponent = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const types_1 = require("../../types");
//@ts-ignore                
let rwsTemplate = T.html `<div class="rws-tools-product-compare-data">
    <div class="compare-header">
        <div class="compare-meta">
            <span class="domain-label">${'productCompare.domain'.t()}:</span>
            <span class="domain-text">${x => { var _a; return (_a = x.productCompareData) === null || _a === void 0 ? void 0 : _a.domain; }}</span>
        </div>
        <div class="compare-products">
            <span class="products-label">${'productCompare.comparing'.t()}:</span>
            <span class="products-text">${x => { var _a, _b; return (_b = (_a = x.productCompareData) === null || _a === void 0 ? void 0 : _a.products) === null || _b === void 0 ? void 0 : _b.join(' vs '); }}</span>
        </div>
        ${(0, fast_element_1.when)(x => { var _a; return (_a = x.productCompareData) === null || _a === void 0 ? void 0 : _a.searchQuery; }, (0, fast_element_1.html) `
            <div class="compare-query">
                <span class="query-label">${'productCompare.searchQuery'.t()}:</span>
                <span class="query-text">"${x => x.productCompareData.searchQuery}"</span>
            </div>
        `)}
    </div>

    ${(0, fast_element_1.when)(x => { var _a, _b, _c; return ((_c = (_b = (_a = x.productCompareData) === null || _a === void 0 ? void 0 : _a.results) === null || _b === void 0 ? void 0 : _b.items) === null || _c === void 0 ? void 0 : _c.length) > 0; }, (0, fast_element_1.html) `
        <div class="results-container">
            <div class="results-list">
                ${(0, fast_element_1.repeat)(x => x.productCompareData.results.items, (0, fast_element_1.html) `
                    <div class="result-item" @click="${(item, c) => c.parent.openLink(item.link)}">
                        <div class="result-header">
                            <h4 class="result-title">${item => item.title}</h4>
                            <div class="result-link">${item => item.link}</div>
                        </div>
                        <div class="result-snippet">
                            ${(item, c) => c.parent.truncateSnippet(item.snippet)}
                        </div>
                    </div>
                `)}
            </div>
        </div>
    `)}

    ${(0, fast_element_1.when)(x => { var _a, _b, _c; return !((_c = (_b = (_a = x.productCompareData) === null || _a === void 0 ? void 0 : _a.results) === null || _b === void 0 ? void 0 : _b.items) === null || _c === void 0 ? void 0 : _c.length); }, (0, fast_element_1.html) `
        <div class="empty-state">
            <span class="empty-icon">📊</span>
            <p>${'productCompare.noResults'.t()}</p>
        </div>
    `)}
</div>
`;
require("./styles/layout.scss");
const styles = T.css `@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.rws-tools-product-compare-data {
  border-radius: 12px;
}
.rws-tools-product-compare-data .compare-header {
  margin-bottom: 20px;
}
.rws-tools-product-compare-data .compare-header h3 {
  font-size: 1.25rem;
  font-weight: 700;
  margin: 0 0 12px 0;
  display: flex;
  align-items: center;
  gap: 10px;
}
.rws-tools-product-compare-data .compare-header .compare-meta, .rws-tools-product-compare-data .compare-header .compare-products, .rws-tools-product-compare-data .compare-header .compare-query {
  background: var(--bg-secondary, #f8f9fa);
  border-radius: 8px;
  padding: 12px 16px;
  border-left: 4px solid var(--primary-color, #007acc);
  margin-bottom: 16px;
}
.rws-tools-product-compare-data .compare-header .compare-meta .query-label, .rws-tools-product-compare-data .compare-header .compare-products .query-label, .rws-tools-product-compare-data .compare-header .compare-query .query-label {
  font-weight: 600;
  color: var(--text-secondary, #6c757d);
  font-size: 0.9rem;
  margin-right: 8px;
}
.rws-tools-product-compare-data .compare-header .compare-meta .query-text, .rws-tools-product-compare-data .compare-header .compare-products .query-text, .rws-tools-product-compare-data .compare-header .compare-query .query-text {
  color: var(--text-primary, #1a1a1a);
  font-weight: 500;
  font-family: monospace;
  background: var(--bg-tertiary, #ffffff);
  padding: 2px 6px;
  border-radius: 4px;
  border: 1px solid var(--border-color-light, #dee2e6);
}
.rws-tools-product-compare-data .compare-header .compare-meta, .rws-tools-product-compare-data .compare-header .compare-products, .rws-tools-product-compare-data .compare-header .compare-query {
  margin-bottom: 8px;
}
.rws-tools-product-compare-data .compare-header .domain-label, .rws-tools-product-compare-data .compare-header .products-label, .rws-tools-product-compare-data .compare-header .query-label {
  font-weight: 600;
  color: var(--text-secondary, #6c757d);
  font-size: 0.9rem;
  margin-right: 8px;
}
.rws-tools-product-compare-data .compare-header .domain-text, .rws-tools-product-compare-data .compare-header .products-text, .rws-tools-product-compare-data .compare-header .query-text {
  color: var(--text-primary, #1a1a1a);
  font-weight: 500;
}
.rws-tools-product-compare-data .results-container .results-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  gap: 8px;
  gap: 12px;
}
.rws-tools-product-compare-data .results-container .results-list .result-item {
  background: var(--bg-tertiary, #ffffff);
  border: 1px solid var(--border-color-light, #dee2e6);
  border-radius: 8px;
  padding: 12px 16px;
  color: var(--text-secondary, #6c757d);
  font-size: 0.9rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  transition: all 0.2s ease-in-out;
  position: relative;
  overflow: hidden;
  cursor: pointer;
}
.rws-tools-product-compare-data .results-container .results-list .result-item:hover {
  transform: translateX(4px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border-color: var(--primary-color, #007acc);
}
.rws-tools-product-compare-data .results-container .results-list .result-item:hover::after {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background: var(--primary-color, #007acc);
}
.rws-tools-product-compare-data .results-container .results-list .result-item {
  padding: 16px;
  flex-direction: column;
  align-items: stretch;
}
.rws-tools-product-compare-data .results-container .results-list .result-item:hover {
  transform: translateY(-2px);
}
.rws-tools-product-compare-data .results-container .results-list .result-item:hover .result-title {
  color: var(--primary-color, #007acc);
}
.rws-tools-product-compare-data .results-container .results-list .result-item .result-header {
  flex: 1;
  min-width: 0;
}
.rws-tools-product-compare-data .results-container .results-list .result-item .result-header .item-title, .rws-tools-product-compare-data .results-container .results-list .result-item .result-header .result-title {
  font-weight: 600;
  color: var(--text-primary, #1a1a1a);
  margin-bottom: 2px;
  word-break: break-word;
}
.rws-tools-product-compare-data .results-container .results-list .result-item .result-header .item-subtitle, .rws-tools-product-compare-data .results-container .results-list .result-item .result-header .result-link {
  font-size: 0.8rem;
  color: var(--text-tertiary, #9ca3af);
  font-family: monospace;
}
.rws-tools-product-compare-data .results-container .results-list .result-item .result-header .item-description {
  color: var(--text-secondary, #6c757d);
  font-size: 0.9rem;
  line-height: 1.5;
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid var(--border-color-light, #dee2e6);
}
.rws-tools-product-compare-data .results-container .results-list .result-item .result-header {
  margin-bottom: 8px;
}
.rws-tools-product-compare-data .results-container .results-list .result-item .result-header .result-title {
  font-size: 1rem;
  transition: color 0.2s ease;
}
.rws-tools-product-compare-data .results-container .results-list .result-item .result-header .result-link {
  font-size: 0.8rem;
  word-break: break-all;
}
.rws-tools-product-compare-data .results-container .results-list .result-item .result-snippet {
  color: var(--text-secondary, #6c757d);
  font-size: 0.9rem;
  line-height: 1.5;
}
.rws-tools-product-compare-data .empty-state {
  text-align: center;
  padding: 32px 16px;
  color: var(--text-secondary, #6c757d);
}
.rws-tools-product-compare-data .empty-state .empty-icon {
  font-size: 3rem;
  margin-bottom: 16px;
  display: block;
  opacity: 0.7;
}
.rws-tools-product-compare-data .empty-state p {
  margin: 0;
  font-size: 1rem;
  font-weight: 500;
}
.rws-tools-product-compare-data .empty-state .empty-suggestion {
  color: var(--text-tertiary, #9ca3af);
  font-size: 0.9rem;
  font-style: italic;
  margin-top: 8px;
}
[data-theme=dark] .rws-tools-product-compare-data .tool-container {
  background: var(--bg-secondary-dark, #2d3748);
}
[data-theme=dark] .rws-tools-product-compare-data .tool-list-item {
  background: var(--bg-tertiary-dark, #374151);
  border-color: var(--border-color-light-dark, #4a5568);
  color: var(--text-secondary-dark, #a0aec0);
}
[data-theme=dark] .rws-tools-product-compare-data .tool-list-item .item-title, [data-theme=dark] .rws-tools-product-compare-data .tool-list-item .results-container .results-list .result-item .result-header .result-title, [data-theme=dark] .rws-tools-product-compare-data .results-container .results-list .result-item .result-header .tool-list-item .result-title {
  color: var(--text-primary-dark, #f7fafc);
}
[data-theme=dark] .rws-tools-product-compare-data .tool-list-item .item-subtitle, [data-theme=dark] .rws-tools-product-compare-data .tool-list-item .results-container .results-list .result-item .result-header .result-link, [data-theme=dark] .rws-tools-product-compare-data .results-container .results-list .result-item .result-header .tool-list-item .result-link {
  color: var(--text-tertiary-dark, #718096);
}
[data-theme=dark] .rws-tools-product-compare-data .tool-list-item .item-description {
  color: var(--text-secondary-dark, #a0aec0);
  border-top-color: var(--border-color-light-dark, #4a5568);
}
[data-theme=dark] .rws-tools-product-compare-data .tool-list-item:hover {
  background: var(--bg-hover-dark, #4a5568);
  border-color: var(--primary-color-dark, #63b3ed);
}
[data-theme=dark] .rws-tools-product-compare-data .tool-list-item:hover::after {
  background: var(--primary-color-dark, #63b3ed);
}
[data-theme=dark] .rws-tools-product-compare-data .tool-query-display {
  background: var(--bg-secondary-dark, #2d3748);
  border-left-color: var(--primary-color-dark, #63b3ed);
}
[data-theme=dark] .rws-tools-product-compare-data .tool-query-display .query-label {
  color: var(--text-secondary-dark, #a0aec0);
}
[data-theme=dark] .rws-tools-product-compare-data .tool-query-display .query-text {
  color: var(--text-primary-dark, #f7fafc);
  background: var(--bg-tertiary-dark, #374151);
  border-color: var(--border-color-light-dark, #4a5568);
}
[data-theme=dark] .rws-tools-product-compare-data .tool-results-summary {
  background: var(--success-color-dark-bg, #1e4d2b);
  border-color: var(--success-color-dark, #68d391);
}
[data-theme=dark] .rws-tools-product-compare-data .tool-results-summary .results-count {
  color: var(--success-color-dark, #68d391);
}
[data-theme=dark] .rws-tools-product-compare-data .tool-empty-state {
  color: var(--text-secondary-dark, #a0aec0);
}
[data-theme=dark] .rws-tools-product-compare-data .tool-empty-state p {
  color: var(--text-primary-dark, #f7fafc);
}
[data-theme=dark] .rws-tools-product-compare-data .tool-empty-state .empty-suggestion {
  color: var(--text-tertiary-dark, #718096);
}
[data-theme=dark] .rws-tools-product-compare-data .tool-loading-state {
  color: var(--text-secondary-dark, #a0aec0);
}
[data-theme=dark] .rws-tools-product-compare-data .tool-loading-state .spinner {
  border-color: var(--border-color-dark, #4a5568);
  border-top-color: var(--primary-color-dark, #63b3ed);
}
@media (max-width: 768px) {
  .rws-tools-product-compare-data {
    padding: 16px;
    margin: 12px 0;
  }
  .rws-tools-product-compare-data h3 {
    font-size: 1.1rem;
  }
  .rws-tools-product-compare-data h4 {
    font-size: 0.95rem;
  }
  .rws-tools-product-compare-data .tool-container {
    padding: 12px;
  }
  .rws-tools-product-compare-data .tool-list-item {
    padding: 10px 12px;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  .rws-tools-product-compare-data .tool-list-item .item-title, .rws-tools-product-compare-data .tool-list-item .results-container .results-list .result-item .result-header .result-title, .rws-tools-product-compare-data .results-container .results-list .result-item .result-header .tool-list-item .result-title {
    font-size: 0.9rem;
  }
  .rws-tools-product-compare-data .tool-list-item .item-description {
    font-size: 0.85rem;
  }
}
@media (max-width: 480px) {
  .rws-tools-product-compare-data .tool-empty-state {
    padding: 24px 12px;
  }
  .rws-tools-product-compare-data .tool-empty-state .empty-icon {
    font-size: 2rem;
  }
  .rws-tools-product-compare-data .tool-empty-state p {
    font-size: 0.9rem;
  }
}`;
const shadowOptions = { "mode": "open" };
let RWSToolsProductCompareDataComponent = class RWSToolsProductCompareDataComponent extends client_1.RWSViewComponent {
    openLink(url) {
        window.open(url, '_blank', 'noopener,noreferrer');
    }
    truncateSnippet(snippet, maxLength = 150) {
        if (!snippet)
            return '';
        return snippet.length > maxLength ? snippet.substring(0, maxLength) + '...' : snippet;
    }
};
exports.RWSToolsProductCompareDataComponent = RWSToolsProductCompareDataComponent;
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_a = typeof types_1.ProductCompareData !== "undefined" && types_1.ProductCompareData) === "function" ? _a : Object)
], RWSToolsProductCompareDataComponent.prototype, "productCompareData", void 0);
exports.RWSToolsProductCompareDataComponent = RWSToolsProductCompareDataComponent = __decorate([
    (0, client_1.RWSView)('rws-tools-product-compare-data', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], RWSToolsProductCompareDataComponent);
RWSToolsProductCompareDataComponent.defineComponent();
